import styled from 'styled-components'
import { space, layout } from 'styled-system'
import { LazyLoadImage } from 'react-lazy-load-image-component'

export const ListingCardContainer = styled.a`
  cursor: pointer;
  border-radius: 5px;
  display: block;
  overflow: hidden;
  margin-bottom: 16px;
  background-color: #fff;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  word-break: break-word;
  text-decoration: none;
  &:hover {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);
  }
`

export const ListingImgAndBannerContainer = styled.div`
  float: left;
  flex: none;
  ${space}
`

export const ListingImg = styled(LazyLoadImage)`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-left: 1rem;
  margin-top: 1rem;
  flex: none;
`

export const FeaturedBannerContainer = styled.div`
  text-align: left;
  margin-top: 0.75rem;
`

export const ListingInfoContainer = styled.div`
  background-color: #fff;
  padding: 1rem;
  border-radius: 5px;
  flex-direction: column;
`

export const ListingHeadingH2 = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: .5rem;
  margin-top: 0rem;
  color: ${(props) => props.theme.colors.textColor};
`

export const ListingHeadline = styled.h2`
  font-size: 1rem;
  margin-bottom: .5rem;
  margin-top: 0rem;
  font-weight: bolder;
  color: ${(props) => props.theme.colors.textColor};
`

export const ListingSpan = styled.span`
  word-break: break-word;
  ${layout}
`

export const ListingCardLocationStatusContainer = styled.div`
  color: ${(props) => props.theme.colors.textColor};
`

export const LocationNameSpan = styled.span`
  font-size: .875rem;
  margin-right: .5rem;
  color: ${(props) => props.theme.colors.textColor};
  display: inline;
`

export const ListingCardLocationLayoutDiv = styled.div`
  font-size: .875rem;
  ${layout}
`

export const LargeOnlineStatus = styled.p`
  font-size: .875rem;
  display: inline;
  ${layout}
`

export const ListingDescriptionP = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.textColor};
`

export const ListingDetailsContainer = styled.div`
  font-size: 1rem;
  float: left;
  color: ${(props) => props.theme.colors.textColor};
`
export const ListingDetailsYearsContainer = styled.div`
  font-size: 1rem;
  padding-right: 1rem;
  padding-top: .5rem;
`

export const ListingDetailsIcon = styled.img`
  align-self: baseline;
  padding-right: .25rem;
  ${layout}
`

export const ListingDetailsExpSpan = styled.span`
  vertical-align: top;
`

export const ListingDetailsPayContainer = styled.div`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.textColor};
`

export const ListingDetailsPayFacetContainer = styled.div`
  font-size: 1rem;
  padding-top: .5rem;
  padding-right: 1rem;
  ${layout}
  color: ${(props) => props.theme.colors.textColor};
`

export const ListingDetailsPaySpan = styled.span`
  vertical-align: text-top;
`
